
export default function TeaLifestyle() {
  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#2C2C2C]" aria-labelledby="tea-lifestyle-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-20 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1.5 bg-white/10 text-white/70 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
              WHY TEA × WORK
            </span>
            <h2 id="tea-lifestyle-heading" className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white mb-6 sm:mb-8 tracking-[0.05em] leading-tight">
              クリエイティブワークに、<br />一杯の静寂を
            </h2>
            <p className="text-sm sm:text-base text-white/60 font-extralight leading-relaxed mb-8 sm:mb-10 tracking-wide">
              コーヒーだけがワークドリンクではありません。日本茶に含まれるL-テアニンは、カフェインの覚醒効果を穏やかにしながら、集中力とリラックスを同時にもたらします。MeVER Chairに座り、Craft Teaを一杯。それが、あなたの最高のクリエイティブモードです。
            </p>

            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-extralight text-[#7B8C3E] mb-2">L-テアニン</div>
                <p className="text-xs text-white/50 font-extralight">集中力を高める<br />アミノ酸</p>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-extralight text-[#7B8C3E] mb-2">カテキン</div>
                <p className="text-xs text-white/50 font-extralight">抗酸化作用で<br />体をサポート</p>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-extralight text-[#7B8C3E] mb-2">ビタミンC</div>
                <p className="text-xs text-white/50 font-extralight">免疫力を<br />サポート</p>
              </div>
            </div>
          </div>

          <div className="relative aspect-[4/5] rounded-xl sm:rounded-2xl overflow-hidden order-1 lg:order-2">
            <img
              src="https://public.readdy.ai/ai/img_res/b5775621afbaf353e4b80b7cc0cdb6d8.jpg"
              alt="クリエイティブワークスペースでの日本茶"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              width="600"
              height="750"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
